import { Drawer } from "@mui/material";
import React, { useEffect, useState } from "react";
import './chatbot.scss'

interface IDrawer {
  open: boolean;
  toggleDrawer: (param: boolean) => void;
}
const Chatbot = ({ open, toggleDrawer }: IDrawer) => {
  return (
    <React.Fragment>
      <Drawer
        open={open}
        onClose={() => {
          toggleDrawer(false);
        }}
        anchor={"right"}
        slotProps={{
          backdrop: {
            sx: {
              backgroundColor: "rgba(255, 255, 255, 0)",
            },
          },
        }}
        PaperProps={{
          sx: {
            borderRadius: 3,
            marginRight: "10px",
            backgroundColor: "#081f6b04",
            backdropFilter: "blur(20px)",
            width: "70%",
            marginTop: "25%",
            height: "75%",

            "@media (orientation: portrait)": {
              width: "70%",
              marginTop: "22vh",
              height: "75%",
            },
            "@media (max-width:820px) and (orientation: landscape)": {
              width: "70%",
              marginTop: "20%",
              height: "75%",
            },
            "@media (min-width:820px) and (max-width:1180px) and (orientation: landscape)":
              {
                width: "55%",
                marginTop: "100px",
                height: "85%",
              },
            "@media (min-width:1181px) and (max-width:1439px) and (orientation: landscape)":
              {
                width: "50%",
                marginTop: "100px",
                height: "85%",
              },
            "@media (min-width:1440px) and (orientation: landscape)": {
              width: "38%",
              marginTop: "60px",
              height: "90%",
            },
          },
        }}
      >
        <div
          style={{
            backgroundColor: "#081f6b",
            color: "white",
            paddingLeft: "10px",
            height: "8%",
            alignContent: "center",
            fontSize: "16px",
            fontWeight: "bold",
          }}
        >
          GridAssist
        </div>
        <iframe
          src="https://dtech.marimo.seqrops.in?access_token=brt@marimo"
          height={"100%"}
          // style={{backgroundColor: "#ffffff"}}
          title="Marimo Chat"
          loading={"eager"}
        />
      </Drawer>
    </React.Fragment>
  );
};
export default Chatbot;
